import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectVersionsShowController extends Controller {}
